import { Grid, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useLanguageContext } from '../../../contexts/LanguageContext';
import { ActionButton } from '../../Button';
import Dialog, { IDefaultDialogProps } from '../../Dialog';
import IGovernanceItem from '../../../interfaces/IGovernanceItem';
import DefaultConstants from '../../../data/Constants';
import htmlParser from 'html-react-parser';


interface IGovernanceItemDescriptionDialogProps extends IDefaultDialogProps {
    governanceItem?: IGovernanceItem;
}


const GovernanceItemDescriptionDialog: React.FC<IGovernanceItemDescriptionDialogProps> = ({
    open,
    handleClose,
    governanceItem = undefined
}) => {
    const { translate } = useLanguageContext();


    const dialogActions = useMemo(() => {
        const elements = [
            <ActionButton action='close' onClick={handleClose} />
        ];

        return elements;
        // eslint-disable-next-line
    }, [translate]);

    
    return (
        <>
            <Dialog
                open={open}
                handleClose={handleClose}
                title={translate('governanceItem')}
                dialogActions={dialogActions}
                className={`dialogactions-flexend overflow-inherit`}
                absolute={true}
                dividers={true}
            >
                <Grid container rowSpacing={DefaultConstants.gridRowSpacing} columnSpacing={DefaultConstants.gridColumnSpacing}>
                    <Grid item md={8} xs={12}>
                        <Typography variant='caption' className='fontsize-10 text-color-2'>
                            {translate('name')}
                        </Typography>

                        <Typography variant='body2'>
                            {governanceItem?.name ?? '-'}
                        </Typography>
                    </Grid>

                    <Grid item md={4} xs={12}>
                        <Typography variant='caption' className='fontsize-10 text-color-2'>
                            {translate('required')}
                        </Typography>

                        <Typography variant='body2'>
                            {translate(governanceItem?.required ? 'yes' : 'no')}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant='caption' className='fontsize-10 text-color-2'>
                            {translate('description')}
                        </Typography>

                        <Typography variant='body2' className='htmlparser-marginnone'>
                            {
                                governanceItem && governanceItem.description.trim().length > 8 ? (
                                    htmlParser(governanceItem.description)
                                ) : (
                                    translate('noDescriptionFound')
                                )
                            }
                        </Typography>
                    </Grid>
                </Grid>
            </Dialog>
        </>
    );
}

export default GovernanceItemDescriptionDialog;